module.exports = __webpack_public_path__ + "static/img/SINGLE_V.a40e941.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/oceantool/SINGLE_V.png
// module id = 7nBy
// module chunks = 18